import { html, css, LitElement } from 'lit'
import NavNode from './nav-node.js'
import './left-item/default.js'
import './left-item/model-range.js'
import './left-item/parent-button.js'

import styleUrl from '../../css/styles.css?url'

window.customElements.define(
    'hedelius-left-column',
    class HedeliusLeftColumn extends LitElement {
        static properties = {
            activeNode: { type: NavNode },
        }

        constructor() {
            super()
            this.activeNode = null
        }

        static styles = css`
            :host {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                overflow-y: auto;
                -ms-overflow-style: none;
                scrollbar-width: none;
            }
        `

        /**
         * Inserts cta-icons into column
         */
        firstUpdated() {
            const menuElement = this.getRootNode().host
            // Query the original icons container from the light DOM of hedelius-menu
            const iconsContainer = menuElement.querySelector('[slot="icons"]')
            if (iconsContainer) {
                const icons = Array.from(iconsContainer.childNodes)
                const localIconsContainer = this.shadowRoot.querySelector('.icons-container')
                icons.forEach((node) => {
                    localIconsContainer.appendChild(node.cloneNode(true))
                })
            }
        }

        renderChild(child) {
            const isActive = child === this.activeNode
            switch (child.entry_type) {
                case 'model_range':
                    return html`
                        <hedelius-left-item-model-range
                            .node=${child}
                            .isActive=${isActive}
                        ></hedelius-left-item-model-range>
                    `
                default:
                    return html`
                        <hedelius-left-item-default
                            .node=${child}
                            .isActive=${isActive}
                        ></hedelius-left-item-default>
                    `
            }
        }

        render() {
            return html`
                <link rel="stylesheet" href="${styleUrl}" />

                <ul class="plus-list scroll-container mt-[54px] pl-10">
                    ${this.activeNode.parent && this.activeNode.parent.title !== 'root'
                        ? html`
                              <hedelius-parent-button
                                  .node=${this.activeNode}
                              ></hedelius-parent-button>
                          `
                        : ''}
                    ${this.activeNode.parent.children.map((child) => this.renderChild(child))}
                </ul>

                <div class="icons-container mt-auto flex w-full justify-center gap-3 py-5"></div>
            `
        }
    }
)
